function showPrivacyPolicy(content) {
	Liferay.Util.openWindow({
		dialog: {
			draggable: false,
			resizable: false,
			cssClass: 'modal-lg',
			headerContent: `<h2>${Liferay.Language.get('privacy-policy-title')}</h2>`,
			bodyContent: content,
			toolbars: {
				footer: [
					{
						label: Liferay.Language.get('privacy-policy-accept'),
						cssClass: 'cds-button-text',
						on: {
							click() {
								localStorage.setItem('privacyPolicyAccepted', 'true');
								Liferay.Util.getWindow('privacy-policy')?.destroy();
							},
						},
					},
				],
			},
			on: {
				render() {
					setTimeout(() => {
						const btn = document.querySelector('#privacy-policy .cds-button-text');
						btn?.setAttribute('cdsButton', '');
						btn?.classList.remove('btn');
					});
				},
			},
		},
		id: 'privacy-policy',
	});
}

const privacyPolicyAccepted = !!localStorage.getItem('privacyPolicyAccepted');
const privacyPolicyContainer = document.querySelector('#privacy-policy-container');
const privacyPolicyContent = document.querySelector('#privacy-policy-container .journal-content-article');
const mobileVersion = document.body.classList.contains('mobile-version');

if (!mobileVersion && !privacyPolicyAccepted && privacyPolicyContainer && privacyPolicyContent) {
	showPrivacyPolicy(privacyPolicyContainer.innerHTML);
}
